//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import provinceData from './city-data/province.js';
import cityData from './city-data/city.js';
import areaData from './city-data/area.js';
export default {
	data() {
		return {
			pickerValue: [0, 0, 0],
			provinceDataList: [],
			cityDataList: [],
			areaDataList: [],
			/* 是否显示控件 */
			showPicker: false,
		};
	},
	created() {
		if(provinceData[0].label === '全部'){
			provinceData.splice(0,1)
			cityData.splice(0,1)
			cityData.map(t => {
				if (t[0].label === '全部') {
					return t.splice(0,1)
				}
			})
			areaData.splice(0,1)
			areaData.map(t => {
				return t.splice(0,1)
			})
			areaData.map(t => {
				t.map(tt => {
					if (tt[0].label === '全部') {
						return tt.splice(0,1)
					}
				})
			})
		} else {
		}
		this.init()
	},
	props: {
		/* 默认值 */
		pickerValueDefault: {
			type: Array,
			default () {
				return [0, 0, 0]
			}
		},
		partial: {
			type: Boolean,
			default: false
		},
		/* 主题色 */
		themeColor: String
	},
	watch: {
		pickerValueDefault() {
			this.init();
		}
	},
	methods: {
		init() {
			this.handPickValueDefault(); // 对 pickerValueDefault 做兼容处理
			this.provinceDataList = provinceData;
			this.cityDataList = cityData[this.pickerValueDefault[0]];
			this.areaDataList = areaData[this.pickerValueDefault[0]][this.pickerValueDefault[1]];
			this.pickerValue = this.pickerValueDefault;
		},
		show() {
			setTimeout(() => {
				this.showPicker = true;
			}, 0);
		},
		maskClick() {
			this.pickerCancel();
		},
		pickerCancel() {
			this.showPicker = false;
			this._$emit('onCancel');
		},
		pickerConfirm(e) {
			this.showPicker = false;
			this._$emit('onConfirm');
		},
		showPickerView() {
			this.showPicker = true;
		},
		handPickValueDefault() {
			if (this.pickerValueDefault !== [0, 0, 0]) {
				if (this.pickerValueDefault[0] > provinceData.length - 1) {
					this.pickerValueDefault[0] = provinceData.length - 1;
				}
				if (this.pickerValueDefault[1] > cityData[this.pickerValueDefault[0]].length - 1) {
					this.pickerValueDefault[1] = cityData[this.pickerValueDefault[0]].length - 1;
				}
				if (this.pickerValueDefault[2] > areaData[this.pickerValueDefault[0]][this.pickerValueDefault[1]].length - 1) {
					this.pickerValueDefault[2] = areaData[this.pickerValueDefault[0]][this.pickerValueDefault[1]].length - 1;
				}
			}
		},
		pickerChange(e) {
			let changePickerValue = e.mp.detail.value;
			if (this.pickerValue[0] !== changePickerValue[0]) {
				// 第一级发生滚动
				this.cityDataList = cityData[changePickerValue[0]];
				this.areaDataList = areaData[changePickerValue[0]][0];
				changePickerValue[1] = 0;
				changePickerValue[2] = 0;
			} else if (this.pickerValue[1] !== changePickerValue[1]) {
				// 第二级滚动
				this.areaDataList = areaData[changePickerValue[0]][changePickerValue[1]];
				changePickerValue[2] = 0;
			}
			this.pickerValue = changePickerValue;
			this._$emit('onChange');
		},
		_$emit(emitName) {
			let pickObj = {
				label: this._getLabel(),
				value: this.pickerValue,
				cityCode: this._getCityCode()
			};
			this.$emit(emitName, pickObj);
		},
		_getLabel() {
			let pcikerLabel =
				this.provinceDataList[this.pickerValue[0]].label +
				this.cityDataList[this.pickerValue[1]].label +
				this.areaDataList[this.pickerValue[2]].label;
			return pcikerLabel;
		},
		_getCityCode() {
			return this.areaDataList[this.pickerValue[2]].value;
		}
	}
};
